/* eslint-disable import/prefer-default-export */
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { MtDriveFile } from "server/models"
import {
    getFileLogo,
    createFileName,
    addModal,
    setDriveOutsideMode,
} from "client/store"
import { Delimiter } from "client/components"

import FileEdit from "client/pages/drive/fileEdit"

import {
    DescriptionWrapper,
    CollapseDescription,

    AttachmentListWrapper,
    AttachmentWrapper,
    AttachmentLogo,
    AttachmentTitle,
} from "./styled"

interface Attachment {
    readonly fileId: number
    readonly file?: MtDriveFile
    readonly order: number
}

interface ViewProps {
    description: string
    attachments: readonly Attachment[]
    commentMode?: boolean
}

export const CKEditorAttachmentsView = ({
    description,
    attachments,
    commentMode = false,
}: ViewProps) => {
    const descriptionRef = useRef<HTMLDivElement>(null)
    const [showDescription, setShowDescription] = useState(true)
    const dispatch = useDispatch()

    useEffect(() => {
        if (commentMode) {
            const bounding = descriptionRef.current.getBoundingClientRect()
            if (bounding.height > 112) setShowDescription(false)
        }
    }, [])

    const showCollapseButton = showDescription === false

    return (
        <Row style={showCollapseButton && attachments.length === 0 ? { paddingBottom: "15px" } : {}}>
            <Col xs={12}>
                <DescriptionWrapper
                    className="ck ck-content"
                    ref={descriptionRef}
                    dangerouslySetInnerHTML={{ __html: description }}
                    show={showDescription}
                />
                {
                    showCollapseButton
                    && <CollapseDescription onClick={() => setShowDescription(true)} />
                }
                {
                    attachments.length > 0
                    && <Delimiter size="sm" />
                }
                {
                    attachments.length > 0 && (
                        <AttachmentListWrapper>
                            {
                                attachments.map((attachment) => {
                                    const { file } = attachment
                                    const version = (file.versions && file.versions[0]) || null
                                    if (!version) return null
                                    return (
                                        <AttachmentWrapper
                                            key={file.id}
                                            inText={false} // don't show in the view mode if a file is added into text
                                            viewMode
                                            onClick={() => {
                                                dispatch(setDriveOutsideMode(true))
                                                dispatch(addModal({
                                                    key: "viewDocument",
                                                    content: <FileEdit fileId={file.id} />,
                                                    onClose: () => dispatch(setDriveOutsideMode(false)),
                                                }))
                                            }}
                                        >
                                            <AttachmentLogo
                                                backgroundSrc={getFileLogo(file, version)}
                                                fileType={version.type}
                                            />
                                            <AttachmentTitle viewMode>
                                                {createFileName(file)}
                                            </AttachmentTitle>
                                        </AttachmentWrapper>
                                    )
                                })
                            }
                        </AttachmentListWrapper>
                    )
                }
            </Col>
        </Row>
    )
}
